import { AuthGuard } from '@/router/guards/AuthGuard.js'
import ManageDocumentsPage from '@/views/Documents/Upload/ManageDocumentsPage.vue'
import PublishedDocumentsPage from '@/views/Documents/Published/PublishedDocumentsPage.vue'

export default [
	{
		path: '/documents/manage',
		name: 'documents.manage',
		component: ManageDocumentsPage,
		meta: {
			authGuard: AuthGuard.RequireDocumentUpload,
			title: 'Documents | Manage'
		}
	},
	{
		path: '/documents/published',
		name: 'documents.published',
		component: PublishedDocumentsPage,
		meta: {
			authGuard: AuthGuard.RequireDocumentDownload,
			title: 'Documents | Published'
		}
	}
]